module.exports = __webpack_public_path__ + "static/media/non-veg.1b9b16fb.png";